import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getQuerystring } from '@plone/volto/actions/querystring/querystring';
import type { GetQueryStringResponse } from '@plone/types';
import SelectWidget from '@plone/volto/components/manage/Widgets/SelectWidget';

export interface FilterWidgetProps {
  indexes: GetQueryStringResponse['indexes'];
}

const FilterWidget: React.FC<FilterWidgetProps> = ({ indexes, ...props }) => {
  const choices: Array<[string, string]> = [];
  Object.entries(indexes).forEach(([value, choice]) => {
    if (
      value !== 'SearchableText' &&
      !choice?.operations?.includes(
        'plone.app.querystring.operation.selection.any',
      ) &&
      !choice?.operations?.includes(
        'plone.app.querystring.operation.date.between',
      )
    )
      return;

    choices.push([value, (choice as { title: string }).title]);
  });
  choices.sort((a, b) => a[1].localeCompare(b[1]));

  return (
    <SelectWidget
      {...props}
      noValueOption={false}
      isMulti={false}
      choices={choices}
    />
  );
};

export default compose(
  injectIntl,
  connect(
    (state: { querystring: GetQueryStringResponse }) => ({
      indexes: state.querystring.indexes,
    }),
    { getQuerystring },
  ),
)(FilterWidget);
